<template>
  <custom-dialog width="600px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-tree
        ref="tree"
        check-strictly
        show-checkbox
        default-expand-all
        :default-checked-keys="defaultCheckedKeys"
        node-key="bizId"
        :data="organTree"
        :props="{ label: 'bizName' }"
        :expand-on-click-node="false"
        highlight-current
      >
        <span class="tree-item" slot-scope="{ node }">
          <span class="line1">{{ node.label }}</span>
        </span>
      </el-tree>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveOrganGroup">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      defaultCheckedKeys: [],
      organTree: [],
    };
  },
  mounted() {
    this.getOrganTree();
  },
  methods: {
    // 获取组织树
    getOrganTree: function () {
      this.defaultCheckedKeys = this.model.defaultCheckedKeys;
      this.$getJSON(apis.DepartmentTree, { orgId: this.model.orgId }).then((res) => {
        this.organTree = [{ disabled: true, ...res.data }];
      });
    },
    // 确认提交
    saveOrganGroup: function () {
      this.visible = false;
      const arr = this.$refs.tree.getCheckedNodes();
      const bizIds = arr.map(t => t.bizId);
      const list = arr.filter(t => [...bizIds, ...t.bizPath.split('/').slice(0, -1)].length === [...new Set([...bizIds, ...t.bizPath.split('/').slice(0, -1)])].length);
      this.$emit(
        'success',
        this.model.orgId,
        list.map(t => ({ toBizType: t.bizType, orgId: this.model.orgId, bizId: t.bizId, bizName: t.bizName }))
      );
    },
  },
};
</script>

<style lang="scss"></style>
